import Actions from './actions.js';
import PageController from './controller/page.js';
export default class WidgetsHandler {
    constructor() {
        Object.defineProperty(this, "containerHandled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        PageController.register(this);
    }
    handleAction(action) {
        switch (action.type) {
            case Actions.PAGE_CONTAINER_READY: {
                if (!this.containerHandled) {
                    this.containerHandled = this.handlePageContainerReadyAction(action.payload);
                }
                break;
            }
            case Actions.FOUND_WIDGETS: {
                const { widgets = [] } = action.payload;
                widgets.forEach(({ rfkId, entity, node }) => {
                    this.handleAddWidget(rfkId, entity, node);
                });
                break;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    handlePageContainerReadyAction(payload) {
        return true;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    handleAddWidget(rfkId, entity, node) { }
}
